export function getAssetURL(asset: string): string {
  return `https://app.layer.ai/static/${asset}`;
}
